"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LostRealtimeSocketMessageModal = require("./LostRealtimeSocketMessageModal");
Object.keys(_LostRealtimeSocketMessageModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LostRealtimeSocketMessageModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LostRealtimeSocketMessageModal[key];
    }
  });
});